'use client';

import { ConnectionState } from 'livekit-client';
import * as React from 'react';
import { SpinnerIcon, Toast, useConnectionState } from '@livekit/components-react';
import { ru } from '@/lib/ru';

export function AgimaConnectionToast() {
  const state = useConnectionState();
  const notification = React.useMemo(() => {
    switch (state) {
      case ConnectionState.Reconnecting:
        return (
          <>
            <SpinnerIcon className="lk-spinner" /> {ru.reconnecting}
          </>
        );
      case ConnectionState.Connecting:
        return (
          <>
            <SpinnerIcon className="lk-spinner" /> {ru.connecting}
          </>
        );
      case ConnectionState.Disconnected:
        return <>{ru.disconnected}</>;
      default:
        return undefined;
    }
  }, [state]);

  return notification ? <Toast className="lk-toast-connection-state">{notification}</Toast> : null;
}
